//hooks
import { useState, useEffect } from 'react';
import { UserConsumer } from '../../hooks/context/UserContext';
import { useApi } from '../../hooks/useApi';

//component
import UpdateProfile from '../../popup/UpdateProfile';
import CompletedRole from '../../popup/CompletedRole';
import Otp from '../../Auth/Otp';
import UserStateDilaog from '../../popup/UserStateDilaog';

//mui
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { Button } from '@mui/material';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';


//mui icon
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import ReplayIcon from '@mui/icons-material/Replay';

//api
import { GetProfileApi } from '../../api/profile/GetProfileApi';
import { GetMyTransactionsListApi } from '../../api/profile/GetMyTransactionsListApi';

//type
import { transactionsListType } from '../../api/profile/type/transactionsListType';

//component
import TranscationCard from '../../component/transactions/TranscationCard';
import NoData from '../../component/NoData';

//image
import transactionPlaceHolder from "../../assets/transactionPlaceHolder.png"


const Profile = () => {
    let {userData,setUserData, theme, setTheme} = UserConsumer()
    const { t } = useTranslation();
    let [openUpdateProfile, setOpenUpdateProfile] = useState<boolean>(false)
    let [openCompletedProfile, setOpenCompletedProfile] = useState<boolean>(false)
    let [openOtp, setOpenOtp] = useState<boolean>(false)
    const [themeRole, setThemeRole] = useState<string>("client");
    const [transactionData, setTransactionData] = useState<transactionsListType[]>([]);
    let [userStateDilaogDilaog, setUserStateDilaogDilaog] = useState<{open:boolean, message:string}>({
        open: false,
        message: "",
    });
    const {
        loading: profileLoading,
        error: profileError,
        HandlerApi: profileApi
    } = useApi(GetProfileApi, "GET");
    const {
        loading: myTransactionsLoading,
        error: myTransactionsError,
        HandlerApi: getMyTransactionslistApi
    } = useApi(GetMyTransactionsListApi, "GET");
    
  useEffect(() => {
    const checkTokenAndFetch = async () => {
        const result = await profileApi();
        setUserData(result.data);
    };
    checkTokenAndFetch();
  }, []);
  useEffect(() => {
    const transactions = async () => {
        const result = await getMyTransactionslistApi();
        setTransactionData(result.data);
    };
    transactions();
  }, [theme]);

    //start functions

    const handleComplete = (type:string)=>{
        setThemeRole(type)
        setOpenCompletedProfile(true)
    }

    //end functions
    
    return (
    <div>
        <div className="py-8">
            { profileLoading
            ?
                <div className='flex justify-center items-center'>
                    <CircularProgress/>
                </div>
            :
            profileError
                ?
                    <div className='cursor-pointer flex justify-center'>
                        <ReplayIcon onClick={()=>{profileApi()}} className='!text-[40px]'/>
                    </div>
                :
                    <div className="flex max-sm:flex-col gap-6 px-4">
                        <div className="sm:w-[35%] sm:sticky sm:top-[120px] h-fit">
                            <div className="bg-white shadow-2xl rounded-lg sm:p-6 p-3">
                                <div className="flex flex-col items-center">
                                    <PersonOutlineIcon sx={{fontSize: "100px"}}/>
                                    <h1 className="lg:text-xl md:text-lg sm:text-sm max-sm:text-xl text-center font-bold">{userData?.full_name}</h1>
                                    <p className="lg:text-lg md:text-sm sm:text-[12px] max-sm:text-lg text-gray-700">{userData?.email}</p>
                                    <div className="mt-6">
                                        <Fab onClick={()=>setOpenUpdateProfile(true)} className={`!w-[40px] !h-[40px] ${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} !text-white`} aria-label="edit">
                                            <EditIcon sx={{fontSize: "20px"}}/>
                                        </Fab>
                                        <UpdateProfile openUpdateProfile={openUpdateProfile} setOpenUpdateProfile={setOpenUpdateProfile}/>
                                    </div>
                                </div>
                                {
                                    userData?.is_verified !== 0
                                    ?
                                    <div className={`flex flex-col`}>
                                        <hr className="my-6 border-t border-gray-300"/>
                                        <div>
                                            <span 
                                            className={`text-gray-700 uppercase font-bold tracking-wider mb-2`}>
                                                {userData?.is_client && userData?.is_driver && userData?.is_host 
                                                ? t("update") 
                                                :userData?.is_client || userData?.is_driver || userData?.is_host
                                                ? t("complete_and_update")
                                                : t("complete")
                                                }
                                            </span>
                                            <div className='flex flex-wrap justify-center text-center gap-2'>
                                                <button onClick={()=>handleComplete("client")} className={`bg-customerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                    {userData?.is_client ? t("update_as_client") : t("complete_as_client")}
                                                </button>
                                                {/* <button onClick={()=>handleComplete("driver")} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                    {userData?.is_driver ? t("update_as_driver") : t("complete_as_driver")}
                                                </button> */}
                                                <button onClick={()=>handleComplete("host")} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                    {userData?.is_host ? t("update_as_host") : t("complete_as_host")}
                                                </button>
                                            </div>
                                        </div>
                                        <hr className="my-6 border-t border-gray-300"/>
                                        <div className={`flex flex-col`}>
                                            <span 
                                            className={`text-gray-700 uppercase font-bold tracking-wider mb-2`}>
                                                {userData?.is_driver || userData?.is_host || userData?.is_client
                                                ? t("switch_to") 
                                                :<></>
                                                }
                                            </span>
                                            <div className='flex flex-wrap justify-center text-center gap-2'>
                                                {theme === "client" 
                                                ? 
                                                <>
                                                    {/* {
                                                        userData?.is_driver
                                                        ?                                  
                                                            <button onClick={()=>{
                                                                userData.driver_confirmed ? setTheme("driver") : setUserStateDilaogDilaog({open: true, message: t("your_driver_account_is_pending_admin_approval")})
                                                            }} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                                {userData?.is_driver ? t("show_as_driver") : ""}
                                                            </button>
                                                        : 
                                                            <></>
                                                    }*/}
                                                    {
                                                        userData?.is_host 
                                                        ?                                  
                                                            <button onClick={()=>{
                                                                userData.host_confirmed ? setTheme("host") : setUserStateDilaogDilaog({open: true, message: t("your_host_account_is_pending_admin_approval")})
                                                            }} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                                {userData?.is_host ? t("show_as_host") : ""}
                                                            </button>
                                                        : 
                                                            <></>
                                                    }
                                                </>
                                                :
                                                theme === "driver"
                                                ?
                                                <>
                                                    {
                                                        userData?.is_client 
                                                        ?                                  
                                                            <button onClick={()=>setTheme("client")} className={`bg-customerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                                {userData?.is_client ? t("show_as_client") : ""}
                                                            </button>
                                                        : 
                                                            <></>
                                                    }
                                                    {
                                                        userData?.is_host 
                                                        ?                                  
                                                            <button onClick={()=>{
                                                                userData.host_confirmed ? setTheme("host") : setUserStateDilaogDilaog({open: true, message: t("your_host_account_is_pending_admin_approval")})
                                                            }} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                                {userData?.is_host ? t("show_as_host") : ""}
                                                            </button>
                                                        : 
                                                            <></>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {
                                                        userData?.is_client 
                                                        ?                                  
                                                            <button onClick={()=>setTheme("client")} className={`bg-customerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                                {userData?.is_client ? t("show_as_client") : ""}
                                                            </button>
                                                        : 
                                                            <></>
                                                    }
                                                    {/* {
                                                        userData?.is_driver 
                                                        ?                                  
                                                            <button onClick={()=>{
                                                                userData.driver_confirmed ? setTheme("driver") : setUserStateDilaogDilaog({open: true, message: t("your_driver_account_is_pending_admin_approval")})
                                                            }} className={`bg-paretnerColor px-5 py-1 w-fit text-white rounded-lg text-[13px]`}>
                                                                {userData?.is_driver ? t("show_as_driver") : ""}
                                                            </button>
                                                        : 
                                                            <></>
                                                    } */}
                                                </>
                                                }
                                            </div>
                                        </div>
                                        <CompletedRole openCompletedProfile={openCompletedProfile} setOpenCompletedProfile={setOpenCompletedProfile} themeRole={themeRole} setThemeRole={setThemeRole}/>
                                    </div>
                                    :<></>
                                }

                            </div>
                        </div>  
                        <div className='sm:w-[65%] max-sm:w-full'>
                            <div>
                                {
                                    userData?.is_verified
                                    ?                         
                                    <Alert severity="success">
                                        {t("your_account_is_verified")}
                                    </Alert>  
                                    :
                                    <>
                                        <Alert
                                            severity="error"
                                            action={
                                            <Button onClick={()=>setOpenOtp(true)} color="inherit" size="small">
                                                {t("verify_now")}
                                            </Button>
                                            }
                                        >
                                            {t("your_account_is_not_verified")}
                                        </Alert>  
                                        <Otp openOtp={openOtp} setOpenOtp={setOpenOtp}/>
                                    </>
                                }
                            </div>
                            <div className="bg-white shadow-2xl rounded-lg sm:p-6 p-3">
                                <h2 className="uppercase font-bold mb-4 text-gray-700">{t("personal_info")}</h2>
                                <div className="text-gray-700">
                                    <div className='flex justify-start gap-10 border-b border-gray-200 sm:p-5 max-sm:py-2'>
                                        <p className='w-[30%]'>{t("full_name")}</p>
                                        <p className='w-[70%] max-sm:text-[14px]'>{userData?.full_name}</p>
                                    </div>
                                    <div className='flex justify-start gap-10 border-b border-gray-200 sm:p-5 max-sm:py-2'>
                                        <p className='w-[30%]'>{t("email")}</p>
                                        <p className='w-[70%] max-sm:text-[14px]'>{userData?.email}</p>
                                    </div>
                                    <div className='flex justify-start gap-10 border-b border-gray-200 sm:p-5 max-sm:py-2'>
                                        <p className='w-[30%]'>{t("phone")}</p>
                                        <p className='w-[70%] max-sm:text-[14px]'>{userData?.phone}</p>
                                    </div>
                                </div>
                            </div>
                            {
                                userData?.is_verified === 1
                                ?
                                <div className='bg-white shadow-2xl rounded-lg sm:p-6 p-3 mt-3'>
                                    <h2 className="uppercase font-bold mb-4 text-gray-700">{theme === "client" ? t("list_of_payments"): t("list_of_receipts")}</h2>
                                    <div>
                                        {
                                            myTransactionsLoading
                                            ?
                                                <div className='flex justify-center items-center'>
                                                    <CircularProgress/>
                                                </div>
                                            :
                                            myTransactionsError
                                                ?
                                                    <div className='cursor-pointer flex justify-center'>
                                                        <ReplayIcon onClick={()=>{getMyTransactionslistApi()}} className='!text-[40px]'/>
                                                    </div>
                                                :       
                                                transactionData?.length === 0
                                                    ? <NoData width={200} title={theme === "client" ? t("payments"): t("receipts")} description={theme === "client" ? t("you_don't_have_any_payments_yet"): t("you_don't_have_any_receipts_yet")} image={transactionPlaceHolder}/>
                                                    :
                                                    <div className='grid lg:grid-cols-2 grid-cols-1 gap-5'>
                                                        {
                                                            transactionData?.map((element: transactionsListType, index: number)=>{
                                                                return (
                                                                    <div key={index}>
                                                                        <TranscationCard element={element}/>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                        }
                                    </div>
                                </div>
                                :<></>
                            }
                        </div>
                    </div>
            }
        </div>
        <UserStateDilaog
        icon={<DoNotDisturbOnIcon className='!text-red-500 !text-[60px]'/>}
        userStateDilaogDilaog={userStateDilaogDilaog}
        setUserStateDilaogDilaog={setUserStateDilaogDilaog}
        />
    </div>
    )
}

export default Profile